var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'flex-grow-1',
        'slide photos',
        {
            'out-of-sync': _vm.outOfSync,
            incomplete: _vm.incomplete,
        },
    ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"slide-top"},[(_vm.incomplete)?_c('div',{staticClass:"slide-icon"},[_vm._t("fallback-icon")],2):_c('div',{class:['thumb-stack', { singular: _vm.singleStack }]},[_vm._t("stack")],2)]),_c('div',{staticClass:"slide-bottom"},[_c('div',{staticClass:"left"},[(_vm.outOfSync)?_c('font-awesome-icon',{attrs:{"icon":"fa-regular fa-clock"}}):(_vm.incomplete)?_c('font-awesome-icon',{attrs:{"icon":"fa-regular fa-info-circle"}}):_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-check"}})],1),_c('div',{staticClass:"right"},[_vm._t("title"),_c('p',{staticClass:"p-0"},[(_vm.outOfSync)?_vm._t("out-of-sync-message"):_vm._t("standard-message")],2)],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }